import { fetchBackofficeGroups, fetchGroupsList, fetchUsersList, createGroup, editGroup, addUserToGroup, deleteGroupUser } from "../../api/backoffice";
import i18n from "@/i18n";

const getDefaultState = () => {
    return {
        groups: [],
        groupsDropdownList: [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
        ],
        usersDropdownList: [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
        ],
        nationalitiesList: [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 1,
                text: "PT",
            },
            {
                value: 2,
                text: "ES",
            },
        ],
        totalPages: 0,
        totalResults: 0,
        isTableLoading: false,
    };
};

const state = getDefaultState();

const getters = {
    getGroups: (state) => state.groups,
    getGroupsDropdownList: (state) => state.groupsDropdownList,
    getUsersDropdownList: (state) => state.usersDropdownList,
    getGroupsTotalPages: (state) => state.totalPages,
    getGroupsTotalResults: (state) => state.totalResults,
    isTableLoading: (state) => state.isTableLoading,
    getNationalitiesList: (state) => state.nationalitiesList,
};

const mutations = {
    setGroups(state, groups) {
        groups = groups?.map((group) => {
            return {
                id: group?.id,
                name: group?.name,
                nationality: group?.nationality,
                status: group?.status,
                children: group?.userGroupChildren
            }
        })
        state.groups = groups;
    },
    setGroupsTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
    setGroupsTotalResults(state, totalResults) {
        state.totalResults = totalResults;
    },
    setTableLoading(state, isTableLoading) {
        state.isTableLoading = isTableLoading;
    },
    setGroupsDropdownList(state, groupsDropdownList) {
        let dropdownNeoObj = groupsDropdownList.map((item) => {
            return {
                value: item["ID"],
                text: item["NAME"],
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state.groupsDropdownList = dropdownNeoObj;
    },
    setUsersDropdownList(state, usersDropdownList) {
        let dropdownNeoObj = usersDropdownList.map((item) => {
            return {
                value: item["ID"],
                text: item["NAME"],
            };
        });

        dropdownNeoObj = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            ...dropdownNeoObj,
        ];

        state.usersDropdownList = dropdownNeoObj;
    },
    resetNationalitiesList(state) {
        state.nationalitiesList = [
            {
                value: -1,
                text: i18n.t("dropdownSelection"),
                disabled: true,
            },
            {
                value: 1,
                text: "PT",
            },
            {
                value: 2,
                text: "ES",
            },
        ];
    }
};

const actions = {
    async getGroups({ commit, rootGetters }, page) {
        commit("setTableLoading", true);
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchBackofficeGroups(
                page.page,
                page.orderBy,
                page?.pageSize,
                idInstance
            );
            commit("setGroups", response?.data?.data);
            commit("setGroupsTotalPages", response?.data?.pages);
            commit("setGroupsTotalResults", response?.data?.total);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async fetchGroupsList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchGroupsList(idInstance);
            commit("setGroupsDropdownList", response?.data?.data);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async fetchUsersList({ commit, rootGetters }) {
        try {
            const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
            const response = await fetchUsersList(idInstance);
            commit("setUsersDropdownList", response?.data?.data);
        } catch (error) {
            console.log(error);
        } finally {
            commit("setTableLoading", false);
        }
    },
    async createGroup({ commit }, groupDataPayload) {
        commit("setTableLoading", false);
        try {
            const response = await createGroup(groupDataPayload);
            return response?.response;
        } catch (error) {
            console.log(error);
        }
    },
    async editGroup({ commit }, { groupDataPayload, groupId }) {
        commit("setTableLoading", false);
        try {
            await editGroup(groupDataPayload, groupId);
        } catch (error) {
            console.log(error);
        }
    },
    async addUserToGroup({ commit }, payload) {
        commit("setTableLoading", false);
        try {
            const response = await addUserToGroup(payload);
            return response?.response;
        } catch (error) {
            console.log(error);
        }
    },
    async deleteGroupUser({ commit }, payload) {
        commit("setTableLoading", false);
        try {
            await deleteGroupUser(payload);
        } catch (error) {
            console.log(error);
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
